import { faro } from '@grafana/faro-react';
import { GrowthBook } from '@growthbook/growthbook';
import {
  autoAttributesPlugin,
  thirdPartyTrackingPlugin,
} from '@growthbook/growthbook/plugins';

import getEnvFromHost from '../../helpers/getEnvFromHost/getEnvFromHost';

const createGrowthBookClient = () => {
  const isProduction = getEnvFromHost() === 'production';

  const growthBookApiHost = isProduction
    ? 'https://www.riverisland.com/cdn/growthbook'
    : 'https://www.ripostprod.com/cdn/growthbook';

  const config = {
    apiHost: growthBookApiHost,
    clientKey: isProduction ? 'sdk-b6lJXkNm1MoDoPFs' : 'sdk-PKKm35QWq6wHFD9',
    enableDevMode: !isProduction,
    plugins: [
      autoAttributesPlugin(),
      thirdPartyTrackingPlugin({
        // Only required for A/B testing
        // Called every time a user is put into an experiment
        additionalCallback: (experiment, result) => {
          if (faro?.api?.pushLog && experiment?.key && result?.key) {
            faro.api.pushLog(['Experiment Viewed'], {
              level: 'info',
              context: {
                experimentId: experiment.key,
                variationId: result.key,
              },
            });
          }
        },
        trackers: ['gtag', 'gtm'],
      }),
    ],
  };

  const client = new GrowthBook(config);

  const autoAttributes = client.getAttributes();

  client.setAttributes({
    ...autoAttributes,
    // Custom attributes can be added here
  });

  return client;
};

export { createGrowthBookClient };
